import { RenderIf } from 'react-rainbow-components';
import { CopyToClipboardButton } from '@rainbow-modules/record';
import { ColumnInfoProps } from 'components/KanbanBoard/types';
import { ColumnInfoContainer } from './styled';

const ColumnInfo = ({
    column,
}: ColumnInfoProps) => (
    <ColumnInfoContainer>
        <RenderIf isTrue={!!column.description}>
            <div>
                <p>{column.description}</p>
            </div>
        </RenderIf>
        <div>
            <p>
                <b>Stage ID: </b>
                {column.name}
            </p>
            <CopyToClipboardButton value={column.name} size="small" borderRadius="semi-square" variant="inverse" />
        </div>
    </ColumnInfoContainer>
);

export default ColumnInfo;
